import { createReducer, on } from "@ngrx/store";
import { DeviceCardList } from "src/model/interface/device-card-list";
import { GenericDeviceCardListStore } from "src/model/interface/generic-device-card-list-store";
import {
  deviceCardAddCodeCardOwnerInValidListAction,
  deviceCardEditExistingCodeInValidListAction,
  deviceCardListErorGenericPopulationAction,
  deviceCardRemoveCodeFromValidListAction,
  deviceCardStartPopulatateValidListAction,
  deviceCardUnsetKeyStorage,
  deviceCardValidListPopulatedAction,
  deviceCardValidListPopulatedOldDataAction,
} from "../actions/device-card.actions";
import { CustomerStaff } from "src/model/class/general classes/customer-staff";

const initialState: GenericDeviceCardListStore = {
  loaded: false,
  error: false,
  validList: null,
  deviceList: null,
  cardOwnerList: null,
  isOldDataInUse: false,
};

/**
 * Reducer for device card list for access control mode version
 */
export const DeviceCardReducer = createReducer(
  initialState,
  on(
    deviceCardUnsetKeyStorage,
    (deviceCardObject: GenericDeviceCardListStore, action) => {
      return initialState;
    }
  ),
  /*
  on(
    deviceCardStartPopulatateValidListAction,
    (deviceCardObject: GenericDeviceCardListStore, action) => {
      return { ...deviceCardObject, loaded: false };
    }
  ),
  */
  on(
    deviceCardValidListPopulatedAction,
    (deviceCardObject: GenericDeviceCardListStore, action) => {
      return {
        loaded: true,
        error: false,
        validList: action.listCard,
        deviceList: action.listDevices,
        cardOwnerList: action.listCardOwners,
        isOldDataInUse: false,
      };
    }
  ),
  on(
    deviceCardValidListPopulatedOldDataAction,
    (deviceCardObject: GenericDeviceCardListStore, action) => {
      return {
        loaded: true,
        error: false,
        validList: action.oldListCard,
        deviceList: action.oldDeviceList,
        cardOwnerList: action.oldCardOwnerList,
        isOldDataInUse: true,
      };
    }
  ),
  on(
    deviceCardListErorGenericPopulationAction,
    (deviceCardObject: GenericDeviceCardListStore, action) => {
      return {
        loaded: true,
        error: true,
        validList: null,
        deviceList: null,
        cardOwnerList: null,
        isOldDataInUse: false,
      };
    }
  ),
  on(
    deviceCardEditExistingCodeInValidListAction,
    (deviceCardObject: GenericDeviceCardListStore, action) => {

      const validListFromStore = [...deviceCardObject.validList];

      //const validList = deviceCardObject.validList.map(
      const validList = validListFromStore.map(
        (deviceCard: DeviceCardList) => {
          if (deviceCard.code === action.updateDeviceCardValidListCode.code) {
            return {
              ...deviceCard,
              expirationDate:
                action.updateDeviceCardValidListCode.expirationDate,
              idTimeSlot: action.updateDeviceCardValidListCode.idTimeSlot,
              idCalendar: action.updateDeviceCardValidListCode.idCalendar,
              idPaymentProfile:
                action.updateDeviceCardValidListCode.idProfilePayment,
            };
          }

          return deviceCard;
        }
      );

      return { ...deviceCardObject, validList };
    }
  ),

  on(
    deviceCardAddCodeCardOwnerInValidListAction,
    (deviceCardObject: GenericDeviceCardListStore, action) => {

      const newCardOwnerList: Array<CustomerStaff> = [...deviceCardObject.cardOwnerList, ...action.newCardOwner];

      return {
        ...deviceCardObject,
        validList: [
          ...deviceCardObject.validList,
          action.newDeviceCardValidListCode,
        ],
        cardOwnerList: newCardOwnerList
      };
    }
  ),

  on(
    deviceCardRemoveCodeFromValidListAction,
    (deviceCardObject: GenericDeviceCardListStore, action) => {
      const updatedValidList: Array<DeviceCardList> =
        deviceCardObject.validList.filter(
          (deviceCard: DeviceCardList) =>
            !(
              deviceCard.code === action.code &&
              deviceCard.idDevice === action.idDevice
            )
        );
      let updatedCardOwnerList: Array<CustomerStaff> = deviceCardObject.cardOwnerList;
      let found: boolean = false;

      for (let i = 0; i < updatedValidList.length && !found; i++) {
        if (updatedValidList[i].cardOwnerID === action.IDCardOwner) {
          found = true;
        }
      }

      if (!found) {
        updatedCardOwnerList =
          deviceCardObject.cardOwnerList.filter(
            (cardOwner: CustomerStaff) =>
            (
              cardOwner.id !== action.IDCardOwner
            )
          );
      }

      return {
        ...deviceCardObject,
        validList: [...updatedValidList],
        cardOwnerList: [...updatedCardOwnerList]
      };
    }
  )
);
